<template>
  <div>
    <template v-if="!isCallingCompany">
      <div class="container-fluid">
        <h2 class="company-title">{{ companyName }}</h2>
        <div class="UserDet">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="input--block">
                <label class="form--label">
                  {{ $t('company_details_company_name').toUpperCase() }}</label>
                <div class="Form-field">
                  <span>{{ companyName }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{
                  $t('company_details_company_address').toUpperCase()
                }}</label>
                <div class="Form-field">
                  <span>{{ companyAddress }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3 col-sm-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{
                  $t('company_details_company_zip_code').toUpperCase()
                }}</label>
                <div class="Form-field">
                  <span>{{ companyZipCode }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{
                  $t('company_details_company_city').toUpperCase()
                }}</label>
                <div class="Form-field">
                  <span>{{ companyCity }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{
                  $t('company_details_company_country_state').toUpperCase()
                }}</label>
                <div class="Form-field">
                  <span>{{ `${companyCountry} - ${companyState}` }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{
                  $t(
                    'company_details_company_registration_number'
                  ).toUpperCase()
                }}</label>
                <div class="Form-field">
                  <span>{{ companyRegistrationNumber }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{
                  $t('company_details_company_time_zone').toUpperCase()
                }}</label>
                <div class="Form-field">
                  <input-select
                    :dataCollection="timeZones"
                    :defaultSelected="currentCompany.timezone"
                    :placeholder="'company_details_company_time_zone'"
                    :label="'value'"
                    ignoreItemTranslation
                    @input="setUserTimeZone($event)"
                  ></input-select>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <i18n
                path="company_details_company_change_information_message"
                tag="span"
                class="Fuell-Text"
                for="contact"
              >
                <a
                  href="#"
                  class="text-primary"
                  @click.prevent="openSupport"
                >{{
                  $t('ACTION_CONTACT_US')
                }}</a>
              </i18n>
            </div>
          </div>

        </div>
        <div class="UserDet">
          <div class="row">
            <div class="col-12 mt-3">
              <h3 class="h3 Fuell-Section--title mb-2">{{$t('company_details_admin_notifications_header')}}</h3>
              <p class="Fuell-Text my-3">{{$t('company_details_admin_notifications_copy')}}</p>
              <div class="row">
                <div class="col-md-3 col-sm-12 pb-5">
                  <div class="input--block">
                    <label
                      for=""
                      class="form--label"
                    >{{$t('company_details_notification_mails_list').toUpperCase()}}</label>
                    <div class="multiselect-custom-field">
                      <multiselect
                        v-model="notificationEmails"
                        :placeholder="$t('company_details_notification_mails_placeholder')"
                        :tag-placeholder="$t('company_details_notification_mails_add_tag_placeholder')"
                        :deselectLabel="$t('company_details_notification_mails_selected_label')"
                        :options="notificationEmails"
                        :multiple="true"
                        :taggable="true"
                        @tag="addEmail"
                        @remove="removeEmail"
                        :select-label="''"
                        :selectedLabel="$t('company_details_notification_mails_selected_label')"
                        :internal-search="true"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :showNoResults="false"
                        :showNoOptions="false"
                      >
                        <div
                          class="caret"
                          slot="caret"
                          slot-scope="{ toggle }"
                          @mousedown.prevent.stop="toggle"
                        >
                          <i
                            class="Ctrl Ctrl--16"
                            aria-hidden="true"
                          >
                            <svg
                              focusable="false"
                              aria-hidden="true"
                              aria-label="Edit"
                            >
                              <use xlink:href="#dropdown-icon"></use>
                            </svg>
                          </i>
                        </div>
                        <template v-slot:noResult>
                          <span>{{$t('MULTISELECT_DEFAULT_NO_RESULTS')}}</span>

                        </template>
                        <template v-slot:noOptions>
                          <span> {{$t('MULTISELECT_DEFAULT_NO_OPTIONS')}}</span>
                        </template>
                      </multiselect>

                    </div>
                  </div>
                </div>
              </div>
              <div
                class="w-100 d-flex justify-content-center"
                v-if="isCalling"
              >
                <spinner />
              </div>

            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="w-100 d-flex justify-content-center">
        <spinner></spinner>
      </div>
    </template>
  </div>
</template>

<script>
import InputSelect from '@/components/Commons/Forms/InputSelect'
import Spinner from '@/components/Commons/Spinner'
import Multiselect from 'vue-multiselect'
export default {
  name: 'CompanyDetailsIndex',
  components: {
    InputSelect,
    Spinner,
    Multiselect
  },
  data () {
    return {
      notificationEmails: [],
      isCalling: false
    }
  },
  methods: {
    async setUserTimeZone (event) {
      if (event && event.target && event.target.value) {
        await this.$store.dispatch('CompanyStore/updateCompany', { officeId: this.officeId, updateInformation: { timezone: event.target.value } })
      }
    },
    async openSupport () {
      let message = this.$t(
        'company_support_update_company_information_message'
      )
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(message)
      }
    },
    async addEmail (event) {
      let email = event.trim()

      const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (validEmailRegex.test(email)) {
        this.notificationEmails.push(email)

        await this.updateNotificationEmails()
      } else {
        this.$store.dispatch('SnackBars/addError', this.$t('company_details_notification_mails_invalid_mail'))
      }
    },
    async removeEmail (event) {
      const emailToRemoveIndex = this.notificationEmails.findIndex(el => el === event)
      if (emailToRemoveIndex >= 0) {
        // this.notificationEmails.splice(emailToRemoveIndex, 1)
        this.notificationEmails = this.notificationEmails.filter(el => el !== event)
        await this.updateNotificationEmails()
      }
    },
    async updateNotificationEmails () {
      let config = {
        configs: [
          {
            code: 'NOTIFICATION_EMAILS',
            config: {
              emails: [...this.notificationEmails]
            }
          }
        ]
      }
      this.isCalling = true
      try {
        await this.$store.dispatch('CompanyStore/updateCompany', { officeId: this.officeId, updateInformation: config })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_details_notification_mail_submit_error' })
      }
      this.isCalling = false
    },
    _initialize () {
      this.notificationEmails = this.companyNotificationEmails ? [...this.companyNotificationEmails] : []
    }
  },
  computed: {
    officeId () {
      return this.$store.getters['CompanyStore/currentCompany'].id || 0
    },
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany'] || false
    },
    companyName () {
      return this.currentCompany && this.currentCompany.name ? this.currentCompany.name : ''
    },
    companyAddress () {
      return this.currentCompany && this.currentCompany.fiscalAddress ? this.currentCompany.fiscalAddress : ''
    },
    companyZipCode () {
      return this.currentCompany && this.currentCompany.fiscalZipCode ? this.currentCompany.fiscalZipCode : ''
    },
    companyCity () {
      return this.currentCompany && this.currentCompany.fiscalCity ? this.currentCompany.fiscalCity : ''
    },
    companyCountry () {
      return this.currentCompany && this.currentCompany.fiscalCountry ? this.$t(`country_name_${this.currentCompany.fiscalCountry.name}`) : ''
    },
    companyState () {
      return this.currentCompany && this.currentCompany.fiscalState ? this.currentCompany.fiscalState : ''
    },
    companyRegistrationNumber () {
      return this.currentCompany && this.currentCompany.registrationNumber ? this.currentCompany.registrationNumber : ''
    },
    isCallingCompany () {
      return this.$store.getters['CompanyStore/isCallingCompany']
    },
    companyNotificationEmails () {
      return this.currentCompany ? this.currentCompany.configs.find(el => el.code === 'NOTIFICATION_EMAILS').config.emails : false
    },
    timeZones () {
      let timezones = []
      for (const zone in this.$store.getters['ConfigStore/privateConfig'].time_zones) {
        timezones.push({ id: zone, value: this.$store.getters['ConfigStore/privateConfig'].time_zones[zone] })
      }
      return timezones
    }
  },
  async created () {
    this._initialize()
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.company-title {
  font-size: 32px;
  font-weight: 400;
  margin-top: 8px;
}
.UserDet {
  margin-top: 25px;
}
.multiselect-custom-field >>> .multiselect__tags {
  background-color: var(--fill-text-area);
  border: none;
}

.multiselect-custom-field >>> .multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 5px 4px 20px;
  border-radius: 5px;
  margin-right: 10px;
  color: var(--fill-main-background);
  line-height: 1;
  background: var(--blue-action-1-active);
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.multiselect-custom-field >>> .multiselect__tag-icon {
  margin: 0px;
  left: 0 !important;
  width: 20px;
}

.multiselect-custom-field >>> .multiselect__tag-icon:hover {
  background: var(--semantic-brand-main);
}

.multiselect-custom-field >>> .multiselect__tag-icon:after,
.multiselect__tag-icon:focus,
.multiselect__tag-icon:focus:after {
  color: var(--fill-main-background) !important;
  background: var(--blue-action-1-active) !important;
}
.multiselect-custom-field >>> .multiselect__tag-icon:hover,
.multiselect__tag-icon:hover:after {
  color: var(--fill-main-background) !important;
  background-color: var(--blue-action-1-active) !important;
}

@media screen and (max-width: 576px) {
  .input--block {
    margin: 10px 0px;
  }
}
.container-fluid {
  padding-left: 0px;
}
</style>
